import React from 'react';

import TopicTiles from '@zola/zola-ui/src/components/PreAuthV3/TopicTiles';

import { WeddingRingsIcon } from '@zola/zola-ui/src/components/SvgIconsV3/WeddingRings';
import { TagIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Tag';
import { MessagesIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Messages';
import { CakeIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Cake';
import { HeartIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Heart';
import { DashboardIcon } from '@zola/zola-ui/src/components/SvgIconsV3/Dashboard';

const AnswersSection: React.FC = (): JSX.Element => {
  const faqsContent = [
    {
      icon: WeddingRingsIcon,
      href: '/faq',
      name: 'For couples',
    },
    {
      icon: TagIcon,
      href: '/faq/category/360004300992-zola-home',
      name: 'For shoppers',
    },
    {
      icon: MessagesIcon,
      href: '/faq/category/115000284811-for-gift-givers-wedding-guests',
      name: 'For wedding guests',
    },
    {
      icon: CakeIcon,
      href: '/faq/category/360000310271-zola-for-vendors-and-wedding-professionals',
      name: 'For wedding vendors',
    },
    {
      icon: HeartIcon,
      href: '/faq/category/115000345571-about-zola',
      name: 'About Zola',
    },
    {
      icon: DashboardIcon,
      href: '/faq/category/200024603-account',
      name: 'Account settings',
    },
  ];

  return (
    <TopicTiles
      title="Find answers to your questions"
      cta={{ text: 'View all our FAQs', href: '/faq' }}
      topics={faqsContent}
    />
  );
};

export default AnswersSection;
